import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import Item from '../list/item'
import ItemLine from '../list/item_line'
// import {itemAPI} from "../api/common";
import {Loading} from "../../common/loadingComponent";

const ListCuration = ({ curation, id, index }) => {
    /* pc, shopping (큐레이션 카테고리) */
    const [active, setActive] = useState(false)
    const { domain } = useSelector(state => state.initial)
    const onClickImg = useCallback(() => {
        if (!active) {
            setActive(true)
        }
    }, [active])

    return (
        <Style id={id} length={curation?.items?.length} pointer={curation.lnk_youtube}>
            <div className="marketing_platform_content">
                {curation?.images?.exp?<img
                    src={active? curation?.images?.exp : curation?.images?.default}
                    alt={curation.nm_curation}
                    onClick={curation.lnk_youtube && onClickImg}
                    width={domain === 'shopping' ? '950' : '890'}
                />:<Loading />}
                {active && (
                    <Iframe
                        title={curation.nm_curation}
                        width={domain === 'shopping' ? '950' : '890'}
                        height={domain === 'shopping' ? '534' : '500'}
                        src={curation.youtube}
                        allow="picture-in-picture"
                    />
                )}
            </div>
            <div className="item_wrap">
                <ItemLine types="thumb">
                    {curation?.items?.map(v => {
                        return <Item key={v.item_id} data={v} fixMode='thumb' like="curation" curationIndex={index} />
                    })}
                </ItemLine>
            </div>
        </Style>
    )
}

const Style = styled.div`
    margin: 0 0 10px;
    min-height: ${props => props.length ? '815px' : 'auto'};

    .marketing_platform_content {
        margin: 0 0 15px;

        img {
            cursor: ${props => props.pointer ? 'pointer' : 'default'}
        }
    }
    .item.thumb {
        &:nth-child(3n) {
            margin-right: 0
        }
    }
`
const Iframe = styled.iframe`
    border: 0
`

export default ListCuration



// WEBPACK FOOTER //
// ./src/estimate_list/components/curation/curations.js